import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4815ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_2 = { class: "subcatalogue" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Альтернативные наименования", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_CatalogueLocalGrid = _resolveComponent("CatalogueLocalGrid")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    "max-width": "1200px",
    onOnShown: _ctx.onShown,
    ref: "dialog",
    onSaveData: _ctx.saveData,
    onClose: _ctx.close
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"]),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_CatalogueLocalGrid, {
            class: "DCatalogueItemCreateEditDialog_dataSubGrid",
            columns: _ctx.columns,
            editingConfig: _ctx.editingConfig,
            selectionConfig: _ctx.selectionConfig,
            designConfig: _ctx.designConfig,
            customDataSource: _ctx.dataGridItems,
            showPageSizeSelector: true,
            pageSize: 10,
            filterRowVisible: true,
            groupPanelVisible: true,
            headerFilterVisible: true,
            filterPanelVisible: false,
            getCreateCallback: _ctx.getCreateData
          }, null, 8, ["columns", "editingConfig", "selectionConfig", "designConfig", "customDataSource", "getCreateCallback"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown", "onSaveData", "onClose"]))
}